import Branding from './BrandingContainer';

export default Branding;
